import React from 'react'
import { Link } from 'gatsby'
import styled from '@emotion/styled'
import PageTitle from '../components/PageTitle'
import NewsletterSignup from '../components/NewsletterSignup'
import Container from '../components/Container'
import Layout from '../components/UnifyLayout'
import SEO from '../components/SEO'
import Img from "gatsby-image"
import Profile from '../components/Profile'

const Text = styled.p`
  text-align: center;
  line-height: 1.6;
  a {
    color: ${props => props.theme.colors.text};
  }
`

const AboutPage = () => (
  <Layout>
    <SEO title="About Hempgrid" description="About Hempgrid" />
      <PageTitle>We are Hempgrid</PageTitle>
      <section className="container g-py-100">
        <p>What if you could harness seasoned, passionate strategists from a wide variety of industries to work on your business, today? And what if they shared a desire to help one versatile plant deliver sustained and sustainable value to communities, businesses and customers worldwide?</p>
        <p>You can. And we do.</p>
        <p>Hempgrid has pooled a team of top manufacturing, legislative, medical and technology experts to strengthen the world’s industrial hemp supply chain. We’re successful when we connect growers, producers, investors, researchers, manufacturers and others in a big, innovative industry.</p>
        <p>Ready to talk? <Link to="/contact">Reach out today!</Link></p>

        <h2 style={{textAlign: "center", margin: "30px 0"}}>The Team</h2>
        <div className="row">
          <Profile 
            image="/images/profiles/ArtiePerry.jpg" 
            name="Artie Perry"
            title="B.S Business Administration - Newberry College; 
            Certificate in Economic Development - University of Oklahoma; 
            Certificate in Finance - Harvard Business School"
            linkedin="linkedin.com/in/artie-perry-onthemove"
          >
            <p>
              With 30+ startups and turnarounds to his credit, 
              Artie has negotiated complex agreements in numerous 
              countries, served government officials, and helped 
              establish or strengthen manufacturing supply chains 
              in the U.S. and abroad.
            </p>

            <p>
              “When links in the chain are weak, they break under 
              pressure and the entire system shuts down. Hemp’s
              enormous promise will never be realized until we apply 
              creativity and ingenuity to its entire life cycle. We 
              aim to be the people who accelerate innovation and 
              commercialization in this exciting industry.”
            </p>
          </Profile>
          <Profile 
            image="/images/profiles/RossAnderson.jpg" 
            name="Ross Anderson"
            title="B.A. Business Management - St. Johns University, MN; 
            Certified Professional Project Manager - University of St. Thomas
            "
            linkedin="https://www.linkedin.com/in/ross-anderson-cppm/"
          >
            <p>
              With more than 15 years experience working for Fortune 500, family-run and non-profit organizations, Ross knits together practical, executive and entrepreneurial experience for Hempgrid members.
            </p>
            <p>
              “We see so much potential for industrial hemp to revive domestic manufacturing and deliver Earth-friendly products and processes. By applying proven methods in project management to this exploding industry, I really believe the sky’s the limit.”
            </p>
          </Profile>
          <Profile 
            image="/images/profiles/JasonEargle.jpg" 
            name="Jason Eargle"
            title="MBA, Entrepreneurship and Innovation - Clemson University; 
            B.S. Finance - Clemson University
            "
            linkedin="https://www.linkedin.com/in/jason-eargle-2802467/"
          >
            <p>
              Jason unites his deep experience as an entrepreneur, a policy wonk, his family’s background in agriculture and a passion for strategy in his work for Hempgrid members.
            </p>
            <p>
              “Working for years in hemp genetics, cultivation, processing and regulation, I see so much untapped potential. I wake up every morning wanting to help harness all this energy so we can strengthen our industry and economy.”
            </p>
          </Profile>
          <Profile 
            image="/images/profiles/HuaSun.jpg" 
            name="Hua Sun"
            title="Ph.D. Engineering - North Dakota State University; 
            Master of Science Biological & Agricultural Engineering - University of Arkansas; 
            Bachelor of Science, Mechanical Engineering - Shandong University of China
            "
            linkedin="https://www.linkedin.com/in/hua-sun-ph-d-74942b9/"
          >
            <p>
              For 30+ years, Hua has been working in the areas of food processing and biomass utilizations. Now, he’s applying his practical and academic experiences to the challenge of sustainably processing hemp fibers often left behind in CBD and fuel production..
            </p>
            <p>
              “Hemp holds so much promise for food packaging and industrial parts, among other things. The domestic economy will be strengthened immeasurably by commercializing this very versatile product, and our team has the insights to accelerate that.”
            </p>
          </Profile>
        </div>

        <div className="row">
          <Profile 
            image="/images/profiles/GaryNestler.jpg" 
            name="Gary Nestler"
            title="BA Organizational Leadership/Communications, Northeastern University; 
            Integrative Medicine, Pacific College of Oriental Medicine; 
            Ph.D Health Administration, Crisis Management, Medical University of South Carolina
            "
            linkedin="https://www.linkedin.com/in/dr-gary-nestler-7a7a2a15/"
          >
            <p>
              Clinically trained as a physician of acupuncture, herbal and neutriceutical medicine, having held licensure in multiple states (SC, FL, NY), Gary has spent the last 30 years “seeing around corners.” As a member of numerous leadership teams at IBM and other high-performance technology organizations, he’s developed specialties in public safety, emergency and crisis management and law enforcement, among others. 
            </p>

            <p>
              “As a key advisor to Hempgrid, I’m eager to imbue a blend of scientific rigor and action orientation into the work the team will do for growth-stage hemp and related organizations.”
            </p>
          </Profile>  
          <Profile 
            image="/images/profiles/MichaelSullivan.jpg" 
            name="Michael Sullivan"
            title="BA Psychology, Dartmouth University; 
            MBA Finance/Marketing, Vanderbilt University
            "
            linkedin="https://www.linkedin.com/in/michaelesullivaneeko/"
          >
            <p>
              Michael spent years growing IBM’s Smart Cities, Smart Water and Watson efforts, leading teams to help apply innovation to some of the worlds most vexing challenges. Today he helms groups of C-level thinkers to tackle what’s next. 
            </p>

            <p>
              “After a century of lying dormant in this domestic marketplace, I see hemp as unlocking countless doors to a sustainable future.”
            </p>
          </Profile>
          <Profile 
            image="/images/profiles/ChrisLaRochelle.jpg" 
            name="Chris LaRochelle"
            title="B.S. in Finance Investment, Babson College"
            linkedin="https://www.linkedin.com/in/chris-larochelle-7231b5158/"
          >
            <p>
              Chris is a senior corporate executive with a keen ability to analyze data, harness it strategically and accelerate growth and profitability. His work with global services and technology companies has focused on finance, accounting and business development. 
            </p>

            <p>
              “I am most enthusiastic about bringing top-level thinking to the hemp industry, and help our members take their dreams to the next level.”
            </p>
          </Profile>
          <Profile 
            image="/images/profiles/BirkHutchens.jpg" 
            name="Birk Hutchens"
            title="BA Sociology and Anthropology, Washington and Lee University
            JD South Texas College of Law
            "
            linkedin="https://www.linkedin.com/in/birk-hutchens-1b275035/"
          >
            <p>
              Birk brings a sharp legal mind and vast experience in commercial litigation, contract claims, employment law and construction litigation to his role here. His career focus has been on asserting the rights of individuals and small businesses. 
            </p>

            <p>
              “Industrial hemp is a fast growing field, and our members deserve to have an experienced attorney in their court as they expand their horizons.”
            </p>
          </Profile>
        </div>

        <div className="row">
          <Profile 
            image="/images/profiles/ColleenTroy.jpg" 
            name="Colleen Troy"
            title="M.A. Media Ecology - New York University; 
            B.A. Communications - Oakland University
            "
            linkedin="https://www.linkedin.com/in/colleentroy/"
          >
            <p>
              Colleen is a communication strategist, entrepreneur and adjunct professor of marketing, and has led teams to deliver nationally recognized and honored work in public relations, social media, marketing and crisis communications.
            </p>

            <p>
              “I’ve spent my career focused on building communities. I think the promise of hemp is to strengthen our country’s rural areas, bolster small family farms and manufacturing facilities, and breathe new life into our heartland.”
            </p>
          </Profile>  
          <Profile 
            image="/images/profiles/KeithCrouch.jpg" 
            name="Keith Crouch"
            title=""
            linkedin="#"
          >
            <p>
              Keith has spent his career on getting the right goods -- food, beverage, beer, wine, spirits, health and beauty products – to the right places at the right time. He’s now applying broad and effective experience in global sourcing, marketing and sales to the nascent hemp industry. 
            </p>

            <p>
              “It’s a blue sky, green fields world out there for hemp, and we’re excited to help businesses seize this moment.”
            </p>
          </Profile>
          <Profile 
            image="/images/profiles/ThomasGlenn.jpg" 
            name="Thomas Glenn"
            title="B.S Intl Business, College of Charleston; 
            MBA Finance - The Citadel
            "
            linkedin="http://linkedin.com/in/thomas-glenn-2732805"
          >
            <p>
              After nearly 20 years as a management strategy consultant and business owner, deep diving into countless industry verticals, business functional areas, and technologies, Thomas discovered that industrial hemp is the perfect fit for his diverse experiences and skills. 
            </p>

            <p>
              “From supply chain to finance, marketing to operations, hemp provides limitless opportunities for innovation, efficiency, and new venture and is poised to impact nearly every industry with its countless uses and broadly achievable economic and environmental benefits.”
            </p>
          </Profile>
          <Profile 
            image="/images/profiles/ShawnHolland.jpg" 
            name="Shawn Holland"
            title="B.S. Economics and Business Administration - 
            Presbyterian College
            "
            linkedin="https://www.linkedin.com/in/shawn-holland-970984a/"
          >
            <p>
              Having spent 20+ years turning bright ideas into viable products and businesses, Shawn has turned his attention to helping hemp industry members create winning go-to-market strategies for B2C and B2B customers.
            </p>

            <p>
              “There is nothing more thrilling than seeing a customer’s “aha moment,” when they realize your product is exactly what they’re looking for. If I can help hemp industry players achieve that moment, I’ll know we’ve been successful.”
            </p>
          </Profile>
        </div>

        <div className="row">
          <Profile 
            image="/images/profiles/StevenHolshouser.jpg" 
            name="Steven Holshouser"
            title="BS Biochemistry, BS Organic Chemistry College of Charleston; 
            Ph.D Drug Discover, Medical University of South Carolina
            "
            linkedin="https://www.linkedin.com/mwlite/in/steven-l-holshouser-691b339b"
          >
            <p>
              Steven has spent a career applying the discoveries made in the lab to a world made better by chemistry. 
            </p>

            <p>
              “I am excited to help develop a new world that is self sustainable and addresses key issues within the scientific community. In utilizing my background in biochemistry, I want to help to grow and implement a low carbon company that is fully sustainable.”
            </p>
          </Profile>  
          <Profile 
            image="/images/profiles/GilShuler.jpg" 
            name="Gil Shuler"
            title="BFA Concentrating in Graphic Design, Western Carolina University"
            linkedin="https://www.linkedin.com/in/gil-shuler-62000215/"
          >
            <p>
              In 1985, Shuler launched Gil Shuler Graphic Design, Inc., which today is a widely recognized leader in communications design. Specializing in branding, research, and strategic thinking, GSGD has served hundreds of high-profile companies in various industries. 
            </p>

            <p>
              “Hemp is an amazing, renewable resource that can be easily grown and processed into a wide variety of applications. It is time we recognize its full potential for industry and manufacturing worldwide.”
            </p>
          </Profile>
          <Profile 
            image="/images/profiles/JamesTurner.jpg" 
            name="James Turner"
            title="B.A. Marketing - Clemson University"
            linkedin="https://www.linkedin.com/in/james-turner1/"
          >
            <p>
              James is a content creator and media strategist working with companies across the country to help tell their story through the power of video content. 
            </p>

            <p>
              “Being able to tell the story of Hemp though video content is such an impactful tool helping spread awareness and take steps to a more sustainable environment.”
            </p>
          </Profile>
          <Profile 
            image="/images/profiles/CourtneyWillcox.jpg" 
            name="Courtney Willcox"
            title="J.D. - Charleston School of Law; 
            B.A. Criminal Justice and Psychology - University of Alabama at Birmingham
            "
            linkedin="https://www.linkedin.com/in/courtney-willcox-53494550/"
          >
            <p>
              Courtney helps drive discovery for a national plaintiff’s law firm and is currently focused on opioid-related litigation.  
            </p>

            <p>
              “I’m passionate about helping to spread the vast educational and medical benefits of industry hemp throughout the world.”
            </p>
          </Profile>
        </div>

      </section>
    <NewsletterSignup />
  </Layout>
)

export default AboutPage
